<template>
<!-- 选择赛卷 -->
    <el-dialog :title="paperTextConfig.chooseTitle" :visible.sync="dialogVisible" width="1000px" @closed="closed" @opened="opened" :close-on-click-modal="false" :close-on-press-escape="false">
        <el-form :inline="true" :model="form" ref="form">
            <el-form-item>
                <span>{{paperTextConfig.chooseTip}}</span>
            </el-form-item>
            <el-form-item style="float: right">
                <el-button type="primary" @click="search(1)">{{ paperTextConfig.form.button.search }}</el-button>
            </el-form-item>
            <el-form-item style="float: right">
                <el-input v-model="form.name" clearable :placeholder="paperTextConfig.form.nameTip"></el-input>
            </el-form-item>
        </el-form>
        <el-table :data="tableData" v-loading="loading" element-loading-text="加载中"
                  element-loading-spinner="el-icon-loading" ref="multipleTable" stripe size="medium"
                  height="500px">
            <el-table-column prop="total_score" :label="tableTextConfig.totalScore"
                             min-width="50">
                <template slot="header" slot-scope="scope">
                    <div style="display: flex;justify-content: center;align-items: center;">
                        <a  @click="chooseAll">{{ tableTextConfig.button.chooseAll }}</a>
                    </div>
                </template>
                <template slot-scope="scope">
                    <el-button :type="showType(scope.row.id)" @click="choose(scope.row)">{{ tableTextConfig.button.choose }}</el-button>
                </template>
            </el-table-column>
            <el-table-column prop="name" :label="tableTextConfig.name"
                             :min-width="flexColumnWidth('name',4,tableData)" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="question_num" :label="tableTextConfig.questionNum" min-width="50">
                <template slot-scope="scope">
                    <el-tooltip placement="right">
                        <div slot="content" style="line-height:22px"><span
                                v-for="(e,j) in scope.row.metas.question_overview"
                                :key="j">{{ e.label }}：{{ e.num }}<br/></span></div>
                        <el-button type="text">{{ scope.row.question_num }}</el-button>
                    </el-tooltip>
                </template>
            </el-table-column>
            <el-table-column prop="total_score" :label="tableTextConfig.totalScore"
                             min-width="50"></el-table-column>
            <el-table-column :label="tableTextConfig.updatedAt" min-width="150px">
                <template slot-scope="scope">
                    <p>{{ scope.row.updated_by_username }}</p>
                    <p class="updateDate">{{ scope.row.updated_at | formatTime }}</p>
                </template>
            </el-table-column>
        </el-table>
        <div>
            <div style="display: inline-block;width: 9%;">
                <span style="line-height: 28px;">已选中：{{chooseData.length}}</span>
            </div>
            <div style="display: inline-block;width: 75%">
                <el-pagination v-show="total"
                               @size-change="handleSizeChange"
                               @current-change="handleCurrentChange"
                               :current-page="form.page_number"
                               :page-sizes="[10, 20, 30, 50]"
                               :page-size="form.page_size"
                               layout="total, sizes, prev, pager, next, jumper"
                               :total="total"
                               background>
                </el-pagination>
            </div>
            <div style="display: inline-block;width: 3%">
            </div>

            <div style="display: inline-block;width: 13%;">
                <el-button type="primary" @click="doConfirm">{{ tableTextConfig.button.ok }}</el-button>
                <el-button @click="closed">{{ tableTextConfig.button.cancel }}</el-button>
            </div>
        </div>

    </el-dialog>
</template>

<script>
import pagination from '@/components/pagination/pagination.vue'
import {judgePermissions} from '@/utils/common.js'

export default {
    components: {
        pagination
    },
    props: ['show', 'choosePapers', 'limitNum', 'examStatus', 'examCategory','oldTableData'],
    data() {
        return {
            dialogVisible: false,
            paperInfoPermissions: false,
            height: 250,
            loading: true,
            form: {
                name: '',
                status: null,
                page_number: 1,
                page_size: 20
            },
            total: 0,
            statusOptions: [{
                label: this.$store.state.global.textConfig.backend.testPaper.table.use.false,
                value: 0
            }, {
                label: this.$store.state.global.textConfig.backend.testPaper.table.use.true,
                value: 1
            }],
            tableData: [],
            editDialogVisible: false,
            row: null,
            chooseData: []
        }
    },
    computed: {
        paperTextConfig() {
            return this.$store.state.global.textConfig.backend.arrangement.examEdit.paper
        },
        tableTextConfig() {
            return this.paperTextConfig.table
        },
        buttonTextConfig() {
            return this.tableTextConfig.button
        }
    },
    beforeRouteEnter(to, from, next) {
        if (from.name === 'testPaperEdit' || from.name === 'testPaperPreview') {
            to.meta.isBack = true
        } else {
            to.meta.isBack = false
        }
        next()
    },
    activated() {
        if (!this.$route.meta.isBack) {
            this.reset()
        } else {
            this.$route.meta.isBack = false
            // this.getBorrowList() /*列表重新加载*/
        }
        this.$route.meta.keepAlive = true
    },
    methods: {
        closed() {
            this.dialogVisible = false
            this.$emit('close')
        },
        opened() {
           this.search(1)
            this.chooseData = JSON.parse(JSON.stringify(this.choosePapers))
        },
        judgePermissions,
        search(val) {
            this.loading = true
            if (val) {
                this.form.page_number = val
            }
            this.$store.dispatch("getPaperList", this.form).then(res => {
                this.loading = false
                this.tableData = res.data.list
                this.total = res.data.total
                this.form.page_number = res.data.pageNumber
                //this.$refs.multipleTable.bodyWrapper.scrollTop = 0;
                for (let i = 0; i < this.tableData.length; i++) {
                    this.tableData[i].metas = JSON.parse(this.tableData[i].metas);
                }
            });
        },
        handleSizeChange(val) {
            this.form.page_size = val
            this.search(1)
        },
        handleCurrentChange(val) {
            this.form.page_number = val
            this.search(val)
        },
        copy(row) {
            this.row = row
            this.editDialogVisible = true
        },
        delet(id) {
            let removeTextConfig = this.buttonTextConfig.remove
            this.$confirm(removeTextConfig.message, removeTextConfig.title, {
                confirmButtonText: removeTextConfig.ok,
                cancelButtonText: removeTextConfig.cancel,
                type: 'warning'
            }).then(() => {
                this.$store.dispatch("deletePaper", id).then(res => {
                    this.$message({
                        type: 'success',
                        message: removeTextConfig.success
                    });
                    if (this.tableData.length == 1) {
                        let num = this.form.page_number == 1 ? 1 : this.form.page_number - 1
                        this.search(num)
                    } else {
                        this.search()
                    }
                });
            }).catch(() => {
            });
        },
        reset() {
            this.form = {
                name: '',
                status: null,
                page_number: 1,
                page_size: 20
            }
            this.search(1)
        },
        choose(row) {
            let choose = this.chooseData.filter((item)=> item.id == row.id)
            if (choose.length == 0) {
                if (this.examCategory == 'normal') {
                    if (this.chooseData.length > 0) {
                        this.$message({
                            type: 'warning',
                            message: '该竞赛类型为正式考，只能选择一份赛卷'
                        });
                    } else {
                        this.chooseData.push(row)
                    }
                } else {
                    if (this.chooseData.length >= this.limitNum) {
                        this.$message({
                            type: 'warning',
                            message: '您选择的赛卷数量已超过限制数量' + this.limitNum,
                        });
                    } else {
                        this.chooseData.push(row)
                    }
                }

            } else {
                if (this.examStatus >= 2) {
                    let data = this.oldTableData.filter((item)=> item.id == row.id)
                    if (data.length == 0) {
                        this.chooseData = this.chooseData.filter((item,index) =>item.id != row.id)
                    }
                } else {
                    this.chooseData = this.chooseData.filter((item,index) =>item.id != row.id)

                }

            }
        },
        chooseAll(){
            let length = this.chooseData.length;
            for (let i = 0; i < this.tableData.length; i++) {
                let choose = this.chooseData.filter((item)=> item.id == this.tableData[i].id)
                if (choose.length == 0) {
                    length = length + 1
                }
            }
            if (length > this.limitNum) {
                this.$message({
                    type: 'warning',
                    message: '您选择的赛卷数量已超过限制数量' + this.limitNum,
                });
            } else {
                for (let i = 0; i < this.tableData.length; i++) {
                    let choose = this.chooseData.filter((item)=> item.id == this.tableData[i].id)
                    if (choose.length == 0) {
                        this.chooseData.push(this.tableData[i])
                    }
                }
            }


        },
        doConfirm() {
            if (this.chooseData.length == 0) {
                this.$message({
                    type: 'warning',
                    message: '请选择赛卷'
                });
            } else {
                if (this.examCategory == 'normal') {
                    if (this.chooseData.length > 1) {
                        this.$message({
                            type: 'warning',
                            message: '该竞赛类型为正式考，只能选择一份赛卷'
                        });
                    } else {
                        this.$emit('choose', this.chooseData)
                        this.closed()
                    }
                } else {
                    if (this.chooseData.length > this.limitNum) {
                        this.$message({
                            type: 'warning',
                            message: '您选择的赛卷数量已超过限制数量' + this.limitNum,
                        });
                    } else {
                        this.$emit('choose', this.chooseData)
                        this.closed()
                    }
                }

            }

        },
        showType(id) {
            let choose = this.chooseData.filter((item)=> item.id == id)
            if (choose.length > 0) {
                return "primary"
            } else {
                return ""
            }
        },
    },
    watch: {
        show() {
            this.dialogVisible = this.show;
        },
    },
    mounted() {
    },
    created() {
        this.judgePermissions(['questionBank:testPaper:info']).then(res => {
            if (res) {
                this.paperInfoPermissions = true
            }
        })
        this.search(1)
    },
}
</script>

<style>

</style>